<template>
  <section class="home home--billboard" ref="billboardSection" v-if="banners.length > 0">
    <!-- Content -->
    <div class="home__content" ref="homeContent">
      <div class="container">
        <HelpersSpotlightFade v-if="windowWidth >= 1280" />
        <div v-if="aosReady" data-aos="fade-up" data-aos-duration="500">

          <div class="row align-items-center">
            <div class="offset-lg-5 col-lg-7">

              <h1 class="sr-only">ShareInvestor Thailand — Online IR Services</h1>

              <div v-html="banners[0].body"></div>

              <div class="home__btn" ref="shinyButton">
                <NuxtLink class="btn btn--primary" :to="localePath('/about-us')" target="_self" >
                  <span class="btn__wrapper">
                    <span class="btn__title">{{ translate('explore.more') }}</span>
                    <span class="btn__icon"><i class="icon-arrow-button"></i></span>
                  </span>
                  <span class="btn__tooltip">{{ translate('about.us') }}</span>
                </NuxtLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>

import { useTranslationStore } from '@/stores/translations'
import { usePostServiceStore } from '@/stores/postService'
import { useShinyButton } from '@/composables/useShinyButton'

import { ref, onMounted, onUnmounted, watch } from 'vue';
import AOS from 'aos';

const postStore = usePostServiceStore();
const translationStore = useTranslationStore()
const translate = translationStore.translate
const { fetchHeroBannerData } = usePostServiceStore();

await fetchHeroBannerData();

const { banners } = storeToRefs(postStore);
const { shinyButton } = useShinyButton()

const windowWidth = ref(0);
const aosReady = ref(true);

const updateWidth = () => (windowWidth.value = window.innerWidth);

const onVideoEnded = () => {
  aosReady.value = true;
  AOS.refresh();
};

watch(aosReady, (newValue) => {
  if (newValue) {
    AOS.init();
  }
});


onMounted(async () => {
  await translationStore.fetchTranslations();

  windowWidth.value = window.innerWidth;
  window.addEventListener("resize", updateWidth);
  AOS.init();

});

onUnmounted(() => {
  window.removeEventListener("resize", updateWidth);
});

defineExpose({
  onVideoEnded
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/app";


</style>
